import 'client/javascript/main';
import WeGlide from 'client/javascript/we_glide/we_glide';
import { Select } from '@wework/ray-core';
import {
  nearbyBuildingsSliderOptions,
  nearbyBuildingsSlider
} from 'client/javascript/pages/home/nearby_buldings/constants';
import { onContentLoaded } from 'client/javascript/on_content_loaded';
import { onPolyfillsLoaded } from 'client/javascript/util/polyfills';
import { trackInteraction, setupScrollAnalyticsTracking } from 'client/javascript/analytics';
import {
  populateNearbyBuildingsSection,
  isNearbyBuildingsAvailable,
  getLocationId
} from 'client/javascript/pages/home/nearby_buldings';
import { setupHeroSlider } from 'client/javascript/pages/home/sections/hero_slider';
import { setupHeroTakeoverModule, HERO_TAKEOVER_CONTAINER } from 'client/javascript/pages/home/sections/hero_takeover';
import CollapsePanel from 'client/shared/collapse_panel';
import PictureTooltip from 'client/shared/picture_tooltip';
import { fetchGeoData } from 'client/javascript/geo';
import { setupBrowseByWorkspaceModuleSection } from 'client/javascript/pages/shared/sections/browse_by_workspace';
import { showVideoCtaModuleByGeolocation } from 'client/javascript/pages/shared/sections/video_cta';
import { setupAllAccessPromoModule } from 'client/javascript/pages/shared/sections/media_text_one_across';
import { setupCardsArticlesBannerModule } from 'client/javascript/pages/shared/sections/cards_articles_banner';
import { setupWizardOverlay } from './wizard/overlay';
import { setupPromoModuleAnalytics } from './analytics';

const selectorBelowFold = '[data-section-id="home-below-fold"]';

fetchGeoData();

onContentLoaded(() => {
  onPolyfillsLoaded(async () => {
    const takeoverModule = document.querySelector(`.${HERO_TAKEOVER_CONTAINER}`);

    setupHeroTakeoverModule();
    setupHeroSlider();
    setupCardsArticlesBannerModule();
    setupAllAccessPromoModule();
    await populateLocationDropdown();
    await populateNearbyBuildingsSection();

    if (isNearbyBuildingsAvailable()) {
      setupSlider(nearbyBuildingsSlider, nearbyBuildingsSliderOptions);
    }
    CollapsePanel.setUp();
    PictureTooltip.setUp();

    setupWizardOverlay();

    // ANALYTICS
    setupLinkAnalyticsTracking();
    setupScrollAnalyticsTracking({
      label: 'homepage scrolled below the fold',
      selector: selectorBelowFold
    });
    setupBrowseByWorkspaceModuleSection();
    showVideoCtaModuleByGeolocation();
    if (takeoverModule) {
      setupPromoModuleAnalytics(takeoverModule);
    }
  });
});

async function populateLocationDropdown() {
  const locationsDropdownSelect = Select.create(document.getElementById('locations-dropdown-select__container'));
  const locationId = await getLocationId();
  locationsDropdownSelect.set(locationId);
}

function setupSlider(selector, options = {}) {
  const glide = new WeGlide(selector, options);
  glide.mount();
}

/* ANALYTICS: clicking anchor tags below the fold */
function setupLinkAnalyticsTracking() {
  const anchorTagsInSectionBelowFold = document.querySelectorAll(`${selectorBelowFold} a`);
  Array.from(anchorTagsInSectionBelowFold).forEach((anchorTag) =>
    anchorTag.addEventListener('click', handleClickAnchorTag)
  );
}

function handleClickAnchorTag(event) {
  const toPath = event.currentTarget.href;
  trackInteraction({ label: 'homepage below the fold content', toPath });
}
